var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.heritedData) ? _c('div', {
    class: ['input-comp', _vm.value.length > 0 ? 'active' : '']
  }, [_c('label', {
    class: ['input-comp--label', _vm.value.length > 0 ? 'active' : '']
  }, [_vm._v(_vm._s(_vm.heritedData.label))]), _vm._v(" "), _c('label', {
    class: ['input-comp--placeholder', _vm.value.length > 0 ? 'active' : '', _vm.heritedData.type === 'textarea' ? 'input-comp--placeholder--text' : '']
  }, [_vm._v(_vm._s(_vm.heritedData.label))]), _vm._v(" "), (_vm.heritedData.type === 'email') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    attrs: {
      "type": "email",
      "name": _vm.heritedData.name
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.heritedData.type === 'textarea') ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    attrs: {
      "name": _vm.heritedData.name
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }) : _vm._e()]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-888b001c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/ui/InputComp.vue
// module id = X0se
// module chunks = 1